/*
 * home-evergreen.js
 * The homepage's shared behaviour. Loaded from snippets/home-evergreen-head.liquid.
 */
(function () {
  /* iOS only applies :active (the pill's pressed wave) once a touch listener exists. */
  document.addEventListener('touchstart', function () {}, { passive: true });
})();
